<template>
    <div class="w-full bg-white border border-t-0 border-gray-200 sm:rounded-b-lg">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
            <p class="mt-1 text-sm leading-5 text-gray-500">
                Cancelling the snooze re-activates this alarm immediately. Notifications will
                resume and the alarm returns to the active list.
            </p>
        </div>
        <div class="px-4 pt-5 pb-0 sm:pb-5 sm:p-0">
            <dl>
                <div class="mt-2 sm:mt-0 sm:grid sm:grid-cols-4 sm:gap-6 sm:px-6 sm:py-5">
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                        Comments<span v-if="requireComment" class="text-red-500 ml-0.5">*</span>
                        <p v-if="requireComment" class="mt-1 text-base font-normal text-gray-500">
                            {{ policyText('requireComment') }}
                        </p>
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3">
                        <textarea v-model="comments" class="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6" rows="4"
                                  placeholder="Enter any comments here"></textarea>
                    </dd>
                </div>
            </dl>
        </div>

        <div class="px-4 pb-5 pt-2 sm:pt-5 sm:border-t mt-2 p-1">
            <div v-if="Object.keys(errorsCancelling).length" class="pb-4">
                <banner-error v-for="(error, errorTitle) in errorsCancelling" :key="errorTitle">
                    <template #title>{{ errorTitle }}</template>
                    <template #content>{{ error }}</template>
                </banner-error>
            </div>
            <div class="flex sm:justify-end">
                <dl class="mb-0 w-full sm:w-auto">
                    <span class="mt-3 inline-flex w-full rounded-md sm:mt-0 sm:w-auto" :class="submitDisabled ? 'cursor-not-allowed' : ''">
                        <button type="button"
                                @click="sendFormData"
                                :disabled="submitDisabled"
                                :class="submitDisabled ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-500 active:bg-blue-700 cursor-pointer'"
                                class="w-full inline-flex items-center justify-center min-w-80 px-4 py-2 border border-transparent font-medium rounded-md text-white focus:outline-none focus:border-blue-700 focus:ring-indigo-200 sm:w-auto sm:text-sm sm:leading-5">
                          Unsnooze
                        </button>
                    </span>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    import BannerError from "@/components/Banners/BannerError.vue";
    import { alarmPolicyText } from "@/support/alarmPolicyCopy";

    export default {
        name: "alarmAddressCancelSnooze",
        mixins: [SonicuCoreMixin],
        components: {BannerError},
        props: {
            sendEventOnly: Boolean,
            requireComment: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                comments: null,
                errorsCancelling: {},
            }
        },
        computed: {
            commentFilled() {
                return !!this.comments && this.comments.trim().length > 0;
            },
            submitDisabled() {
                return this.requireComment && !this.commentFilled;
            },
        },
        methods: {
            policyText(key) {
                return alarmPolicyText(key);
            },
            sendFormData() {
                this.errorsCancelling = {}
                let data = {
                    'addressed': 'cancel-snooze',
                    'comments': this.comments,
                }

                if (this.sendEventOnly) {
                    this.$emit('cancelling-snooze', data)
                    return
                }

                axios.patch(window.location.pathname, data).then(response => {
                    let payload = response.data
                    if (_.size(payload.errors) > 0) {
                        this.errorsCancelling = payload.errors;
                        setTimeout(() => { window.location.reload() }, 10000);
                        return
                    }
                    window.location.href = this.company.buildCompanyRoute('alarms');
                    return false;
                }).catch(error => {
                    if (error.response && error.response.data && error.response.data.errors) {
                        this.errorsCancelling = error.response.data.errors;
                    }
                })
            }
        }
    }
</script>
